import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { LoggerGuardService } from './logger-guard.service'

export const loggerGuard: CanActivateFn = (route, state) => {
  return inject(LoggerGuardService).isValid()
}